import {Component, Input, OnInit} from '@angular/core';
import {InteractionAnswerSaveDto, InteractionCardDto, InteractionDto} from '../../models/card.model';
import {ConferenceService} from '../../service/conference.service';

@Component({
  selector: 'app-interaction',
  templateUrl: './interaction.component.html',
  styleUrls: ['./interaction.component.scss'],
})
export class InteractionComponent implements OnInit {

  @Input() set interaction(interaction: InteractionDto) {
    if (interaction) {
      this.initInteraction(interaction);
    } else {
      this.clearInteraction();
    }
  };

  @Input() set isResults(isResult: boolean) {
    this._isResults = isResult;
    if (!isResult) {
      this.firstCard();
    }
  };
  @Input() isWordCloudReady: boolean = false;

  _isResults: boolean = false;

  interactionId: string = null;
  interactionData = null;
  cards: InteractionCardDto[] = [];
  activeCardIndex: number = 0;
  activeCard: InteractionCardDto = null;

  constructor(
    private conferenceService: ConferenceService,
  ) {
  }

  ngOnInit() {
  }

  initInteraction(interaction: InteractionDto) {
    if (interaction
      && interaction.interactionsGroups && interaction.interactionsGroups.length > 0
      && interaction.interactionsGroups[0].interactionsCards && interaction.interactionsGroups[0].interactionsCards.length > 0
    ) {
      this.interactionData = interaction;
      this.cards = interaction.interactionsGroups[0].interactionsCards;
      if (this.cards.length > 0) {
        this.activeCardIndex = 0;
        this.activeCard = this.cards[0];
      }
    } else {
      this.clearInteraction();
    }
  }

  clearInteraction() {
    this.interactionData = null;
    this.cards = [];
    this.activeCardIndex = 0;
    this.activeCard = null;
  }

  firstCard() {
    this.activeCardIndex = 0;
    this.activeCard = this.cards.length > 0 ? this.cards[this.activeCardIndex] : null;
  }

  nextCard() {
    if (this.canGoNext()) {
      this.activeCardIndex++;
      this.activeCard = this.cards[this.activeCardIndex];
    }
  }

  prevCard() {
    if (this.canGoPrev()) {
      this.activeCardIndex--;
      this.activeCard = this.cards[this.activeCardIndex];
    }
  }

  canGoNext() {
    return (this.activeCardIndex < this.cards.length - 1)
      && (
        this._isResults
        || !this.activeCard.isRequired
        || this.activeCard.isRequired && this.activeCard.cardAnswer && this.activeCard.cardAnswer.isCompleted);
  }

  canGoPrev() {
    return this.activeCardIndex > 0;
  }

  onSubmitHandler(payload: InteractionAnswerSaveDto) {
    console.log('onSubmitHandler', payload);
    this.conferenceService.saveAnswer(payload).then((data) => {
      console.log('saveAnswer', data);
      this.mergeAnswer(payload);
    }).catch((e) => {
      console.log('saveAnswer error', e);
    });
  }

  mergeAnswer(payload: InteractionAnswerSaveDto) {
    if (this.activeCard) {
      this.activeCard.cardAnswer = {
        ...this.activeCard.cardAnswer,
        ...{
          isCompleted: payload.isCompleted,
          score: payload.score,
          groupExtId: payload.groupExtId,
        },
      };

      if (payload.text) {
        this.activeCard.cardAnswer.formAnswer = {
          ...this.activeCard.cardAnswer.formAnswer,
          ...{
            text: payload.text
          },
        };
      }

      if (payload.InteractionAnswerItems && this.activeCard.interactionsCardItems) {
        this.activeCard.interactionsCardItems.map((item) => {
          const answerItem = payload.InteractionAnswerItems.find((answerItem) => answerItem.interactionsCardItemId === item.id);
          if (answerItem) {
            item.cardItemAnswer = {
              ...item.cardItemAnswer,
              ...{
                value: answerItem.value,
                valueText: answerItem.valueText,
                score: answerItem.score,
              },
            };
          }
        });
      }
    }
  }
}
